import { RoutePath } from "src/types/path";

export const PAGE_TITLES: RoutePath = {
  auth: {
    login: "ログイン",
  },
  users: {
    root: "アプリアカウント一覧",
  },
  operations: {
    root: "運用機能",
    detail: {
      suspendApp: "メンテナンス状態の変更",
      updateNotification: "アップデート通知",
      termsReconsent: "利用規約の再同意",
      municipalityData: "市区町村データ",
    },
  },
  pushNotifications: {
    root: "通知履歴",
    detail: {
      send: "通知送信",
      edit: "通知編集",
    },
  },
  accountManagement: {
    root: "アカウント管理",
    create: "新規作成",
    detail: "アカウント詳細",
  },
  myAccount: {
    root: "マイアカウント",
    changePassword: {
      root: "パスワード変更",
      complete: "パスワード変更が完了しました。",
    },
  },
  error: {
    404: `お探しのページは見つかりませんでした。`,
  },
} as const;

export const MENU_TITLES = {
  users: "アプリアカウント一覧",
  operations: "運用機能",
  pushNotifications: "PUSH通知",
  accountManagement: "アカウント管理",
  myAccount: "マイアカウント",
};
